import {Component} from "@angular/core";
import {AlertController, LoadingController, NavController, NavParams, ToastController,} from "ionic-angular";
import {EcoEnelEmpresasProvider} from "../../../providers/ecoenel-empresas/ecoenel-empresas.provider";
import {ReciclagemDetalhePage} from "../reciclagem-detalhe/reciclagem-detalhe";

/**
 * Pagina para Grande Gerador criar reciclagem
 * No reenvio, pre-popula evento e reciclador do lancamento original.
 * Nota: Nao usa lazy loading - declarada no modulo pai
 */
@Component({
  selector: "page-reciclagem-criar",
  templateUrl: "reciclagem-criar.html",
})
export class ReciclagemCriarPage {
  eventos: any[] = [];
  recicladores: any[] = [];
  recursos: any[] = [];
  recursosFiltrados: any[] = [];

  eventoSelecionado: any = null;
  recicladorSelecionado: any = null;
  dataReciclagem: string = "";
  observacoes: string = "";
  contratoGerador: any = null;
  contratoReciclador: any = null;

  residuosAdded: any[] = [];
  recursoSelecionado: any = null;
  inputQuantidade: number;
  filtroRecurso: string = "";

  // Vigencias do recurso selecionado
  vigenciasDisponiveis: any[] = [];
  vigenciaSelecionada: any = null;

  // Reenvio: lancamento original passado via navParams
  lancamentoOrigem: any = null;
  isReenvio: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public provider: EcoEnelEmpresasProvider,
    public alertCtrl: AlertController,
    public loadCtrl: LoadingController,
    public toastCtrl: ToastController
  ) {
    this.lancamentoOrigem = this.navParams.get("lancamentoOrigem") || null;
    this.isReenvio = !!this.lancamentoOrigem;
    this.dataReciclagem = new Date().toISOString().split("T")[0];
    this.carregarDadosIniciais();
    this.carregarContratoGerador();
  }

  carregarDadosIniciais() {
    // Carregar eventos disponiveis
    this.provider.getEventosDisponiveis().subscribe(
      (data) => {
        this.eventos = data || [];
        if (this.isReenvio) {
          this.prePopularReenvio();
        }
      },
      (err) => {
        this.showToast("Erro ao carregar eventos");
      }
    );

    // Se reenvio, pre-popular data
    if (this.isReenvio && this.lancamentoOrigem && this.lancamentoOrigem.data_reciclagem) {
      this.dataReciclagem = this.lancamentoOrigem.data_reciclagem.split("T")[0];
    }

    // Se reenvio, pre-popular observacoes
    if (this.isReenvio && this.lancamentoOrigem && this.lancamentoOrigem.observacoes) {
      this.observacoes = this.lancamentoOrigem.observacoes;
    }
  }

  /**
   * Reenvio: pre-popula evento e reciclador a partir do lancamento original.
   * O form de residuos fica livre para o usuario adicionar qualquer residuo.
   */
  prePopularReenvio() {
    var origem = this.lancamentoOrigem;
    if (!origem) return;

    // Selecionar evento
    var eventoId = origem.evento_id || (origem.evento && origem.evento.id);
    if (eventoId) {
      for (var i = 0; i < this.eventos.length; i++) {
        if (this.eventos[i].id === eventoId) {
          this.eventoSelecionado = this.eventos[i];
          break;
        }
      }
    }

    if (!this.eventoSelecionado) return;

    // Carregar recicladores do evento, depois selecionar
    this.provider.getRecicladores(this.eventoSelecionado.id).subscribe(
      (data) => {
        this.recicladores = data || [];
        var recicladorId = origem.reciclador_id || (origem.reciclador && origem.reciclador.id);
        if (recicladorId) {
          for (var i = 0; i < this.recicladores.length; i++) {
            if (this.recicladores[i].id === recicladorId) {
              this.recicladorSelecionado = this.recicladores[i];
              this.onRecicladorChange();
              break;
            }
          }
        }
      }
    );
  }

  carregarContratoGerador() {
    this.provider.getMeuContratoGerador().subscribe(
      (data) => {
        this.contratoGerador = data || null;
      },
      (err) => {
        console.warn("Nao foi possivel carregar contrato do gerador");
      }
    );
  }

  onEventoChange() {
    this.recicladorSelecionado = null;
    this.contratoReciclador = null;
    this.recursos = [];
    this.recursosFiltrados = [];
    this.limparRecursoSelecionado();

    if (!this.eventoSelecionado) {
      this.recicladores = [];
      return;
    }

    // Carregar recicladores filtrados por evento
    this.provider.getRecicladores(this.eventoSelecionado.id).subscribe(
      (data) => {
        this.recicladores = data || [];
      },
      (err) => {
        this.showToast("Erro ao carregar recicladores");
      }
    );
  }

  onRecicladorChange() {
    this.contratoReciclador = null;
    this.recursos = [];
    this.recursosFiltrados = [];
    this.limparRecursoSelecionado();

    if (!this.recicladorSelecionado) {
      return;
    }

    // Carregar contrato do reciclador
    this.provider.getContratoReciclador(this.recicladorSelecionado.id).subscribe(
      (data) => {
        this.contratoReciclador = data || null;
        if (!this.contratoReciclador) {
          this.showToast("Nenhum contrato encontrado para este reciclador");
        }
      },
      (err) => {
        this.showToast("Erro ao carregar contrato do reciclador");
      }
    );

    // Carregar recursos do evento
    if (this.eventoSelecionado) {
      this.provider.getRecursosDoEvento(this.eventoSelecionado.id).subscribe(
        (data) => {
          this.recursos = data || [];
          this.recursosFiltrados = this.recursos.slice(0, 5);
        },
        (err) => {
          this.showToast("Erro ao carregar recursos");
        }
      );
    }
  }

  // Metodos para filtro de recursos
  filtrarRecursos() {
    if (!this.filtroRecurso || this.filtroRecurso.trim() === "") {
      // Sem busca: mostrar os 5 primeiros
      this.recursosFiltrados = this.recursos.slice(0, 5);
      return;
    }

    const termo = this.filtroRecurso.toLowerCase().trim();
    this.recursosFiltrados = this.recursos.filter((rec) => {
      const nome = (rec.nome || "").toLowerCase();
      const tipo = (rec.tipoRecurso && rec.tipoRecurso.nome ? rec.tipoRecurso.nome : "").toLowerCase();
      return nome.includes(termo) || tipo.includes(termo);
    }).slice(0, 10);
  }

  selecionarRecurso(recurso: any) {
    this.recursoSelecionado = recurso;
    this.filtroRecurso = "";
    this.recursosFiltrados = [];
    this.vigenciasDisponiveis = [];
    this.vigenciaSelecionada = null;

    // Carregar vigencias para este recurso+evento+reciclador
    if (this.eventoSelecionado && this.recicladorSelecionado) {
      this.provider.getVigenciasRecurso(
        this.eventoSelecionado.id,
        this.recicladorSelecionado.id,
        recurso.id
      ).subscribe(
        (data) => {
          this.vigenciasDisponiveis = data || [];
          // Se so tem uma vigencia, seleciona automaticamente
          if (this.vigenciasDisponiveis.length === 1) {
            this.vigenciaSelecionada = this.vigenciasDisponiveis[0];
          }
        },
        (err) => {
          this.showToast("Erro ao carregar vigencias");
        }
      );
    }
  }

  limparRecursoSelecionado() {
    this.recursoSelecionado = null;
    this.filtroRecurso = "";
    this.recursosFiltrados = this.recursos.slice(0, 5);
    this.vigenciasDisponiveis = [];
    this.vigenciaSelecionada = null;
  }

  adicionarResiduo() {
    if (!this.recursoSelecionado) {
      return this.showAlert("Selecione um tipo de residuo");
    }
    if (!this.vigenciaSelecionada) {
      return this.showAlert("Selecione uma vigencia");
    }
    if (!this.inputQuantidade || this.inputQuantidade <= 0) {
      return this.showAlert("Informe a quantidade");
    }

    // Verificar se ja existe esse recurso
    const existente = this.residuosAdded.find(
      (r) => r.recurso_id === this.recursoSelecionado.id
    );
    if (existente) {
      return this.showAlert("Este recurso ja foi adicionado");
    }

    var quantidade = parseFloat(String(this.inputQuantidade)) || 0;
    var valorUnitario = this.vigenciaSelecionada.valor;
    var valorTotal = quantidade * valorUnitario;

    this.residuosAdded.push({
      recurso_id: this.recursoSelecionado.id,
      nome: this.recursoSelecionado.nome,
      quantidade: quantidade,
      valor_unitario: valorUnitario,
      valor_total: valorTotal,
      unidade: (this.recursoSelecionado.unidadeMedida && this.recursoSelecionado.unidadeMedida.sigla) || "kg",
      vigencia_id: this.vigenciaSelecionada.id,
    });

    this.inputQuantidade = null;
    this.limparRecursoSelecionado();
  }

  removerResiduo(index: number) {
    this.residuosAdded.splice(index, 1);
  }

  calcularValorTotal(): number {
    return this.residuosAdded.reduce((sum, r) => sum + (r.valor_total || 0), 0);
  }

  enviarReciclagem() {
    if (!this.eventoSelecionado) {
      return this.showAlert("Selecione um evento");
    }
    if (!this.recicladorSelecionado) {
      return this.showAlert("Selecione um reciclador");
    }
    if (!this.contratoReciclador) {
      return this.showAlert("Contrato do reciclador nao encontrado. Selecione o reciclador.");
    }
    if (!this.dataReciclagem) {
      return this.showAlert("Informe a data da reciclagem");
    }
    if (this.residuosAdded.length === 0) {
      return this.showAlert("Adicione pelo menos um residuo");
    }

    const load = this.loadCtrl.create({ content: "Enviando reciclagem..." });
    load.present();

    var lancamento: any = {
      evento_id: this.eventoSelecionado.id,
      reciclador_id: this.recicladorSelecionado.id,
      contrato_id: this.contratoReciclador.id,
      data_reciclagem: this.dataReciclagem,
      observacoes: this.observacoes ? this.observacoes.trim() : null,
      residuos: this.residuosAdded.map((r) => ({
        recurso_id: r.recurso_id,
        quantidade: r.quantidade,
        valor_unitario: r.valor_unitario,
        vigencia_id: r.vigencia_id || null,
      })),
    };

    if (this.contratoGerador && this.contratoGerador.id) {
      lancamento.contrato_gerador_id = this.contratoGerador.id;
    }

    if (this.isReenvio && this.lancamentoOrigem) {
      lancamento.lancamento_origem_id = this.lancamentoOrigem.id;
      // Copiar contrato_gerador_id do original se nao tiver um proprio
      if (!lancamento.contrato_gerador_id && this.lancamentoOrigem.contrato_gerador_id) {
        lancamento.contrato_gerador_id = this.lancamentoOrigem.contrato_gerador_id;
      }
    }

    this.provider
      .criarLancamento(lancamento)
      .then((data) => {
        load.dismiss();
        this.showToast("Reciclagem enviada com sucesso!");
        var novoId = data && data.data && data.data.id;
        if (novoId) {
          // Volta pra lista e abre o detalhe da nova reciclagem
          var views = this.navCtrl.getViews();
          var listaIndex = this.isReenvio ? views.length - 3 : views.length - 2;
          if (listaIndex < 0) listaIndex = 0;
          this.navCtrl.popTo(views[listaIndex]).then(function() {
            this.navCtrl.push(ReciclagemDetalhePage, { id: novoId });
          }.bind(this));
        } else {
          this.navCtrl.pop();
        }
      })
      .catch((err) => {
        load.dismiss();
        this.showAlert(err.msg || "Erro ao enviar reciclagem");
      });
  }

  formatCurrency(value: any): string {
    var num = parseFloat(value);
    if (!num || isNaN(num)) return "R$ 0,00";
    return "R$ " + num.toFixed(2).replace(".", ",");
  }

  showAlert(msg: string) {
    this.alertCtrl
      .create({ title: "Aviso", message: msg, buttons: ["OK"] })
      .present();
  }

  showToast(msg: string) {
    this.toastCtrl.create({ message: msg, duration: 3000 }).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/ecoenel-empresas/reciclagem-criar/reciclagem-criar.ts